// extracted by mini-css-extract-plugin
export default {"list":"summary-module--list--YQNBc","anchor":"summary-module--anchor--iY0Xd"};